export const TIP_TEST_IDS = {
    TIP_CONTAINER: "TIP_CONTAINER",
    TIP_TITLE: "TIP_TITLE",
    TIP_INPUT_BOX: "TIP_INPUT_BOX",
    ERROR: "ERROR_MESSAGE",
    CONFIRM_TIP_BUTTON: "CONFIRM_TIP_BUTTON",
    CUSTOM_TIP_CLOSE: "CUSTOM_TIP_CLOSE",
    CUSTOM_TIP_CONTAINER: "CUSTOM_TIP_CONTAINER",
};
